/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI Template
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 *
 * @export
 * @interface Warning
 */
export interface Warning {
  /**
   *
   * @type {number}
   * @memberof Warning
   */
  code?: number;
  /**
   *
   * @type {number}
   * @memberof Warning
   */
  duration_limit?: number;
  /**
   *
   * @type {string}
   * @memberof Warning
   */
  message: WarningMessageEnum;
  /**
   *
   * @type {string}
   * @memberof Warning
   */
  reason: string;
  /**
   *
   * @type {number}
   * @memberof Warning
   */
  seq_no?: number;
  /**
   *
   * @type {string}
   * @memberof Warning
   */
  type: WarningTypeEnum;
}

export const WarningMessageEnum = {
  Warning: 'Warning',
} as const;

export type WarningMessageEnum =
  typeof WarningMessageEnum[keyof typeof WarningMessageEnum];
export const WarningTypeEnum = {
  DurationLimitExceeded: 'duration_limit_exceeded',
} as const;

export type WarningTypeEnum =
  typeof WarningTypeEnum[keyof typeof WarningTypeEnum];
